<template>
  <div class="d-flex h-100 w-100 justify-content-center login-container">
    <div class="align-self-center">
      <div class="card login-panel">
        <div class="card-header">Reset password
        </div>
        <div class="card-body">
          <b-form-group
            label="Username" label-for="username">
            <b-form-input ref="usernameInput" id="username"
                          v-model="username" required
                          placeholder="Enter username"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="card-footer">
          <b-btn-group class="btn-block">
            <b-button class="btn-block btn-lg" :disabled="loading" variant="secondary" @click="cancel">Cancel</b-button>
            <b-button class="btn-block" :disabled="loading || !username" @click.stop.prevent="onSubmit" type="submit" variant="primary">
              Submit
            </b-button>
        </b-btn-group>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'request-reset-password',
    data () {
      return {
        loading: false,
        username: ''
      }
    },
    methods: {
      onSubmit () {
        let formData = new FormData()
        formData.append('username', this.username)
        this.loading = true
        this.$http.post('/api/request-password-reset', formData)
          .then(res => {
            this.$notify({
              title: 'SUCCESS',
              text: 'Email with instructions was sent.',
              type: 'success'
            })
            this.loading = false
            setTimeout(() => {
              location.href = '/'
            }, 4000)
          }, res => {
            this.$notify({
              title: 'ERROR',
              text: 'Could not request reset password. Please, check if username is correct.',
              type: 'error'
            })
            this.loading = false
          })
      },
      cancel () {
        location.href = '/'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/RequestResetPassword.vue